import React from 'react';
import { Grid, Typography } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import stepIcon from '../../../assets/registration/input_phone.png'
import InputForm from '../../../components/forms/InputForm';
import InputSelectForm from '../../../components/forms/InputSelectForm';
import ContainedButton from '../../../components/actions/ContainedButton';
import DisplayError from '../../../components/alerts/DisplayError';
import {makeStyles} from '@mui/styles'

/**
 * @module Layouts/Registration/views/PhoneNumberRequest
 * @description This is a React component that renders a form for users to enter their phone number and sends a
 * validation code to that number.
 * @returns {React.ReactElement} The `PersonalDataForm` component is being returned as a View.
 */

/**
 * 
 * @typedef PhoneNumberRequest
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Boolean} loading - Indicates if initialization process is taking place
 * @property {Boolean} sending - Indicates if a process has started
 * @property {Object | String | Boolean} error - Variable that handles error, it can be a boolean, a string or an object 

 * @property {Object} form - Form with fields of country area code and phone number
 * @property {Function} onSendSMSv2 - This function sends an SMS to the user with a Pin Number

 */
const PhoneNumberRequest = ({data, form, actions, system}) => {

    const classes = useStyles()
    return ( 
        <div className={classes.root}>
            <div>
            
            </div>
            <Grid container spacing={3} >
                <Grid item xs={12}>
                    <div className={classes.image_container}>
                        <img src={stepIcon} alt='' width='100%'/>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h6' align='center' className={classes.title}>
                        Enter your phone number
                    </Typography>
                    <Typography variant='body1' align='center' className={classes.text}>
                        We'll send a code to the registered number to validate your identity
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item>
                            <div style={{width:100}}>
                                <InputSelectForm data={form.country_code_area} onChange={actions.onChangeForm} />
                            </div>
                        </Grid>
                        <Grid item xs>
                            <InputForm data={form.cell_phone_number} onChange={actions.onChangeForm} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <DisplayError>{system.error}</DisplayError>
                    <ContainedButton loading={system.sending}
                        disabled={!data.valid_captcha || !form.cell_phone_number.isValid} 
                        //disabled={!form.cell_phone_number.isValid} 
                        fullWidth color='primaryDark'
                        onClick={actions.onSendSMSv2}
                    >Continue</ContainedButton>
                </Grid>
            </Grid>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        width:'100%',
        maxWidth:400,
        margin:'auto',
        padding:'40px 0px'
    },
    image_container:{
        width:200,
        margin:'auto',
        [theme.breakpoints.down('sm')]:{
            width:150,
        }
    },
    title:{
        fontWeight:600,
        lineHeight:1.5,
    },
    text:{
        fontWeight:500,
        color:blueGrey[400],
        [theme.breakpoints.down('sm')]:{
            fontSize:'0.875rem'
        }
    }
}))
 
export default PhoneNumberRequest;